'use client';

import { useTranslations } from 'next-intl';
// import { useParams } from 'next/navigation';
import BaseAuctionCard from './BaseAuctionCard';

interface CompletedAuctionCardProps {
  id: string;
  title: string;
  location: string;
  finalPrice: number;
  image: string;
  isFavorite?: boolean;
  onFavoriteToggle?: (id: string) => void;
  isAuthenticated?: boolean; // Server-side'dan gelecek
}

export default function CompletedAuctionCard({
  id,
  title,
  location,
  finalPrice,
  image,
  isFavorite = false,
  onFavoriteToggle,
  isAuthenticated = false
}: CompletedAuctionCardProps) {
  const t = useTranslations('auctions');
  // const params = useParams();

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  const favoriteButton = isAuthenticated && onFavoriteToggle ? (
    <button
      onClick={() => onFavoriteToggle(id)}
      className="absolute top-4 right-4 w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-colors"
    >
      <svg 
        className={`w-5 h-5 ${isFavorite ? 'text-red-500 fill-current' : 'text-gray-600'}`} 
        fill={isFavorite ? 'currentColor' : 'none'} 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    </button>
  ) : null;

  const imageOverlay = (
    <>
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="border-4 border-white rounded-lg p-6 transform -rotate-12">
          <p className="text-white text-2xl font-bold font-serif">{t('sold')}</p>
        </div>
      </div>
    </>
  );

  const content = (
    <div className="flex justify-between items-center mt-auto">
      <span className="text-sm text-gray-700 font-normal">{t('salePrice')}:</span>
      <span className="text-lg font-bold text-green-600 tabular-nums">{formatPrice(finalPrice)}</span>
    </div>
  );

  return (
    <BaseAuctionCard
      id={id}
      title={title}
      location={location}
      image={image}
      isCompleted={true}
      imageOverlay={imageOverlay}
      favoriteButton={favoriteButton}
    >
      {content}
    </BaseAuctionCard>
  );
}
